import { useEffect, useState } from "react";
import "./AtivarOrigemCarregamentoTrilhosNovosModal.css";

export default function AtivarOrigemCarregamentoTrilhosNovosModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao ativar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocnat-bg" onClick={onClose}>
      <div className="ocnat-box" role="dialog" aria-modal="true" aria-label="Ativar origem novos" onClick={(e) => e.stopPropagation()}>
        <header className="ocnat-head">
          <h3 className="ocnat-title">Ativar</h3>
          <button className="ocnat-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="ocnat-body">
          Deseja <strong>ativar</strong> "{titulo || "esta origem"}"?
          {err ? <div className="ocnat-err">{err}</div> : null}
        </div>
        <footer className="ocnat-foot">
          <button className="ocnat-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ocnat-btn ocnat-btn-ok" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Ativando..." : "Ativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}

